import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const ProductReplacementPartsPurchaseInfo = ({
  children,
  className,
  currency,
  price,
  unitPrice
}) => {
  const [t] = useTranslation();
  const getPriceSuffix = currency
    ? ` ${currency} ${t('ITEM_EA_ABB')}`
    : ` ${t('ITEM_EA_ABB')}`;
  const showUnitPrice = unitPrice && unitPrice !== price;
  return (
    <div className={cx('d-flex flex-column', className)}>
      <div className={'ms-0 me-auto'}>
        <p className="text-end fw-bold text-md u-color--ExtraDarkGray">
          {`${price}${getPriceSuffix}`}
        </p>
        {showUnitPrice && (
          <p className={'text-end text-md text-univers u-color--DarkGray'}>
            <span className="text-md text-line-through text-univers u-color--DarkGray">
              {unitPrice}
            </span>
            {getPriceSuffix}
          </p>
        )}
      </div>
      {children}
    </div>
  );
};

ProductReplacementPartsPurchaseInfo.propTypes = {
  catEntryId: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  currency: PropTypes.string,
  price: PropTypes.string,
  unitPrice: PropTypes.string
};

export default ProductReplacementPartsPurchaseInfo;
